import { render, staticRenderFns } from "./InvestorBusinessConstitutiveDocument.vue?vue&type=template&id=529b8df6&"
import script from "./InvestorBusinessConstitutiveDocument.vue?vue&type=script&lang=js&"
export * from "./InvestorBusinessConstitutiveDocument.vue?vue&type=script&lang=js&"
import style0 from "./InvestorBusinessConstitutiveDocument.vue?vue&type=style&index=0&id=529b8df6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports